import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

type Props = { artistId: string; poolName: string };

export const deleteIpPool = async ({ artistId, poolName }: Props) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!poolName) throw Error('Pool name is required');

  // The pool name is its identity and travels in the URL path, so it has to be encoded.
  const url = `/web/studio/artists/${artistId}/ip-pools/${encodeURIComponent(poolName)}`;

  const response = await api.executeDeleteRequest<ObjectResponse<unknown>>(url);

  return response.data;
};
